@if (companyProfile(); as companyProfile) {
  <div class="contractor">
    <onyx-avatar
      variant="company"
      [size]="32"
      [company]="{ logo: undefined }"
    ></onyx-avatar>

    <div class="contractor-wrapper">
      <p>{{ companyProfile.displayName }}</p>

      <div class="contractor-container f-body-s f-muted">
        <span class="nip">
          {{ 'labels.vatId' | translate }}:
          {{ companyProfile.country | uppercase }}{{ companyProfile.vatId }}
        </span>

        @if (showSince()) {
          @if (companyData(); as companyData) {
            <span class="start-date">
              {{ 'labels.from' | translate | lowercase }}
              {{ companyData.companyStartDate | onyxDate: 'date-dot' }}
            </span>
          } @else {
            -
          }
        }
      </div>
    </div>
  </div>
} @else {
  -
}
